if (typeof TableOfContents !== 'function') {
	class TableOfContents extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				articleContent: '.article__content',
				anchor: '.anchor',
			};

			this.elements = {
				articleContent: document.querySelector(this.selectors.articleContent),
				titles: [],
			};

			this.init();
		}

		init() {
			this.selectTitles();

			if (this.elements.titles.length !== 0) {
				this.addAnchors();
				this.generateTableOfContents();
			} else {
				this.parentNode.removeChild(this);
			}
		}

		selectTitles() {
			const includedHeadings = this.getAttribute('data-includes').split(',');
			const allHeadingsWithText = [];

			includedHeadings.forEach((heading) => {
				const selector = `${this.selectors.articleContent} ${heading.trim()}`;
				const headingElements = Array.from(document.querySelectorAll(selector));
				const filteredHeadings = headingElements.filter((headingElement) => {
					return this.elements.articleContent.contains(headingElement);
				});

				allHeadingsWithText.push(
					...filteredHeadings.map((headingElement) => {
						return {
							text: headingElement.textContent,
							element: headingElement,
						};
					})
				);
			});

			allHeadingsWithText.sort((a, b) => {
				const aPos = a.element.compareDocumentPosition(b.element);

				return aPos & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
			});

			this.elements.titles = allHeadingsWithText.map((heading) => heading.element);
		}

		addAnchors() {
			this.elements.titles.forEach((element, index) => {
				const anchor = document.createElement('div');

				anchor.setAttribute('class', 'anchor');
				anchor.setAttribute('id', `title${index + 1}`);
				anchor.setAttribute('data-text', element.textContent);
				anchor.setAttribute('data-type', element.tagName.toLowerCase());

				element.parentElement.insertBefore(anchor, element);
			});
		}

		generateTableOfContents() {
			this.innerHTML = `${this.dataset.title}`;
			document.querySelectorAll(this.selectors.anchor).forEach((element) => {
				if (element.dataset.text) {
					this.innerHTML += `<a href="#${
						element.attributes.id.nodeValue
					}" data-type="${element.dataset.type.toLowerCase()}">${element.dataset.text}</a>`;
				}
			});
		}
	}

	if (!customElements.get('table-of-contents')) {
		customElements.define('table-of-contents', TableOfContents);
	}
}
